import { Dialog } from "primereact/dialog";
import { CustomButton } from "../CustomButton";
import { useSelector, useDispatch } from "react-redux"
import { deleteCustomer, resetSelectedCustomer } from "../../reducers/customerTableSlice";
import { deleteCategory, resetSelectedCategory } from "../../reducers/categoryTableSlice"
import { deleteProduct, resetSelectedProduct } from "../../reducers/productTableSlice";
import * as Messag from '../../config/ToastMessage';
import { changeShowNotice } from "../../reducers/appSlice";
import { delCampaignById, resetCampaignData } from "../../reducers/campaignSlice";
import CONSTANTS from "../../config/Constants";
import { Text } from "../Text";
export const DeleteAlert = ({ item, displayAlertDelete, setDisplayAlertDelete, toast }) => {
  const { selectedCustomer } = useSelector(state => state.customerTable);
  const { selectedCategory } = useSelector(state => state.categoryTable);
  const { selectedProduct } = useSelector(state => state.productTable);
  const { campDetails } = useSelector(state => state.shareMessage);

  const dispatch = useDispatch();

  const deleteProductItem = () => {
    dispatch(deleteProduct(selectedProduct.id))
      .unwrap()
      .then(res => {
        dispatch(changeShowNotice(true))
        //show toast here
        let Message_Success = Messag.Delete_Product_ToastSuccessMessage;
        toast.current.show({ severity: 'success', detail: Message_Success });
      })
      .catch(err => {
        //show toast here
        toast.current.show({ severity: 'error', detail: err.response.data });
      })
  }
  const deleteCategoryItem = () => {
    dispatch(deleteCategory(selectedCategory.id))
      .unwrap()
      .then(res => {
        //show toast here
        let Message_Success = Messag.Delete_Cat_ToastSuccessMessage;
        toast.current.show({ severity: 'success', detail: Message_Success });
      })
      .catch(err => {
        //show toast here
        toast.current.show({ severity: 'error', detail: err.response.data });
      })
  }
  const deleteCustomerItem = () => {
    dispatch(deleteCustomer(selectedCustomer.id))
      .unwrap()
      .then(res => {
        //show toast here
        let Message_Success = Messag.Delete_Cust_ToastSuccessMessage;
        toast.current.show({ severity: 'success', detail: Message_Success });
      })
      .catch(err => {
        //show toast here
        toast.current.show({ severity: 'error', detail: err.response.data });
      })
  }
  const deleteScheduleItem = () => {
    dispatch(delCampaignById(campDetails.id))
      .unwrap()
      .then(res => {
        //show toast here
        toast.current.show({ severity: 'success', detail: "Schedule Campaign is Deleted" });
      })
      .catch(err => {
        //show toast here
        toast.current.show({ severity: 'error', detail: err.response.data });
      })
  }

  const onHide = () => {
    setDisplayAlertDelete(false)
    switch (item) {
      case 'product':
        dispatch(resetSelectedProduct())
        break;
      case 'category':
        dispatch(resetSelectedCategory())
        break;
      case "customer":
        dispatch(resetSelectedCustomer())
        break;
      case "schedule":
        dispatch(resetCampaignData())
        break;
      default:
        break;
    }
  }
  const handleDelete = () => {
    switch (item) {
      case 'product':
        deleteProductItem()
        break;
      case 'category':
        deleteCategoryItem()
        break;
      case "customer":
        deleteCustomerItem()
        break;
      case "schedule":
        deleteScheduleItem()
        break;
    }
    onHide();
  }

   const message = () => {
    switch (item) {
      case 'product':
        return CONSTANTS.PRODUCT_DELETE_CONFIMATION
        break;
      case 'category':
        return CONSTANTS.CATEGORY_DELETE_CONFIMATION
        break;
      case "customer":
        return CONSTANTS.CUSTOMER_DELETE_CONFIMATION        
        break;
      default:
        return CONSTANTS.DELETE_CONFIRMATION
    }
    
  }


  const dialogFooter = () => {
    return (
      <div className="flex justify-content-end">
        <CustomButton label="Yes" varient="filled" icon="pi pi-check" onClick={handleDelete} />
        <CustomButton label="No" varient="cancel" icon="pi pi-times" autofocus={true} onClick={onHide} />
      </div>
    );
  };
  return (
    <Dialog
      header="Alert"
      visible={displayAlertDelete}
      prevCss={false}
      footer={dialogFooter()}
      onHide={onHide}
      style={{ width: "45vw" }}
      className={'dialog-custom'}
    >
      <div className={`flex flex-column  gap-3`}>
          <Text className={`alertText`} >
          {message()}
          </Text>
        </div>
    </Dialog>
  );
};
